import { render, staticRenderFns } from "./AgentSettingPage.vue?vue&type=template&id=1087c606&scoped=true"
import script from "./AgentSettingPage.vue?vue&type=script&lang=js"
export * from "./AgentSettingPage.vue?vue&type=script&lang=js"
import style0 from "./AgentSettingPage.vue?vue&type=style&index=0&id=1087c606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087c606",
  null
  
)

export default component.exports